import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  TextField,
  Tab,
  Tabs,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  Autocomplete,
  InputAdornment,
  IconButton,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Menu,
  TablePagination,
  Dialog,
  DialogTitle,
  DialogContent,
  TableFooter,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import ListIcon from '@mui/icons-material/List';
import InfoIcon from '@mui/icons-material/Info';
import RefreshIcon from "@mui/icons-material/Refresh";
import CloseIcon from '@mui/icons-material/Close';
import CancelIcon from '@mui/icons-material/Cancel';
import SearchIcon from '@mui/icons-material/Search';
//import { IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ClearIcon from '@mui/icons-material/Clear';
import AddIcon from '@mui/icons-material/Add';
import VisibilityIcon from '@mui/icons-material/Visibility';
import GetAppIcon from '@mui/icons-material/GetApp';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import TableChartIcon from '@mui/icons-material/TableChart';
import ArticleIcon from '@mui/icons-material/Article';
import DescriptionIcon from '@mui/icons-material/Description';
// import {
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import axios from "axios";
import { IBonDeCaisse, ICompte, ISimulationBDC2 } from "../../../dataTypes/GlobalDataType";
import { Crypter } from "../../../Functions/Security/Crypter";
import Data from '../../../Data/Data.json';
import { useAuthHeader, useAuthUser } from '../../../Services/Auth/sessionAuth';
import Utilisateur from "../../../Models/Utilisateur";
import { fetchDataTable2, formatDate, GlobalExportToCSV, GlobalExportToExcel, GlobalExportToJSON, GlobalExportToPDF, GlobalExportToWord } from "../../../utilitaires/globalFunction";
import formatNumber from "../../../Functions/Traitement/FormatNumber";
import SweetAlert from "sweetalert2";
import Swal from "sweetalert2";   
import withReactContent from "sweetalert2-react-content";
import SaveIcon from '@mui/icons-material/Save';
import UpdateIcon from '@mui/icons-material/Update';
import { init } from "i18next";
import DataType from "../../../Types/DataTablePiclist";
import DoneIcon from '@mui/icons-material/Done';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import BlockIcon from '@mui/icons-material/Block';
import { Filter } from "@mui/icons-material";
//import DescriptionIcon from "@mui/icons-material/Description";

//import CancelIcon from '@mui/icons-material/Cancel';

export default function VisualisationBDC() {
     const auth = useAuthUser()
         
          const authHeader = useAuthHeader()
      
  const Perss: Utilisateur = JSON.parse(JSON.stringify(auth()))
  const [tab, setTab] = useState(0);
  const [data, setData] = useState<IBonDeCaisse[]>([]);
  const [selected, setSelected] = useState<IBonDeCaisse | null>(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [page, setPage] = useState(0); // Page actuelle
  const [rowsPerPage, setRowsPerPage] = useState(5); // Tu peux ajuster le nombre par défaut ici
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [anchorElInt, setAnchorElInt] = useState<null | HTMLElement>(null);
  const [simulations, setSimulations] = useState<ISimulationBDC2[]>([]);
  const [compte, setCompte] = useState<ICompte []>([]);
  const [selectedCpt, seSelectedCpt] = useState<ICompte []>([]);
  const [activ, setActiv] = useState(true); // Page actuelle

  const [openDialog, setOpenDialog] = useState(false);
  const [codOpe, setCodOpe] = useState('');
   const [libOpe, setLibOpe] = useState('');
   const [cdetat, setCdetat] = useState("01"); // Page actuelle

   
  //const [resultat, setResultat] = useState<any>(null);

// const [echeancier, setEcheancier] = useState<
//   { periode: number; dateImput: string;  interet: number; taxe: number; netAPayer: number }[]
// >([]);
const [echeancier, setEcheancier] = useState<{
  periode: number;
  dateImput: string;
  interet: number;
  taxe: number;
  netAPayer: number;
}[]>([]);

 const [resultat, setResultat] = useState({
  montInt: 0,
  montTaxe: 0,
  montNet: 0,
 // echeancier: [],
});  
const totalInteret = echeancier.reduce((acc, row) => acc + row.interet, 0);
const totalTaxe = echeancier.reduce((acc, row) => acc + row.taxe, 0);
const totalNet = echeancier.reduce((acc, row) => acc + row.netAPayer, 0);
 
  const { register, handleSubmit, reset,setValue, control,watch } = useForm<IBonDeCaisse>({
  defaultValues: {
  IDBDC: 0,
  NUMBDC: "",
  REFBDC: "",
  CODSIMUL: "",
  NUMCLI: "",
  NOMCLI: "",
  TYPBDC: "",
  TYPIMPUTINT: "",
  FREQPROV: "",
  DUREE: "",
  MONTANT: "",
  TXINT: "",
  MTNINT: "",
  MTNNETAPAYER: "",
  TXTAXE: "",
  MTNTAXE: "",
  MTNPROVFREQ: "",
  MTNTAXEFREQ: "",
  // DATDEBUT:  new Date(Perss.datjour).toISOString(),
  // DATFIN: new Date(Perss.datjour).toISOString(),
  DATDEBUT: new Date(Perss.datjour).toISOString().substring(0, 10),
  DATFIN: new Date(Perss.datjour).toISOString().substring(0, 10),
  CODOPE: "",
  LIBOPE:"",
  CPTDEPOT: "",
  CPTBDC: "",
  CPTINTCLI: "",
  CPTINT: "",
  CPTPROV: "",
  CPTTAXE: "",
  CPTTAXEDEB: "",
  CPTTAXECRE: "",
  CDETAT: "",
  CODAGE: Perss.codage,
  DATCRE: new Date(Perss.datjour),
  UTISAI: Perss.coduti,
  UTIVAL: "",
  DATVAL: new Date(Perss.datjour),
  HEUREVAL: new Date().toISOString(),
  DISPONCPTDEPOT: "",
  DISPONCPTBDC: "",
  DISPONCPTINT: ""
  },
});

 const cptDepot = watch("CPTDEPOT");
 const cptBDC = watch("CPTBDC");
 const cptIntCli = watch("CPTINTCLI");



  const api = "http://localhost:5000/api/BDC"; // 👉 à adapter selon ton API
const MySwal = withReactContent(Swal);
 
  
  
  // 🔹 Ouvre le menu
    const handleClickExport = (event: React.MouseEvent<HTMLButtonElement>) => {
      setAnchorEl(event.currentTarget);
    };
    // 🔹 Ouvre le menu
    const handleClickExportInt = (event: React.MouseEvent<HTMLButtonElement>) => {
      setAnchorElInt(event.currentTarget);
    };
   // 🔹 Fonctions d’exportation (à implémenter selon ton besoin)
    const handleExport = (format: any) => {
      handleCloseExport();
      switch (format) {
        case 'excel':
         // console.log('Export Excel', data);
          GlobalExportToExcel(paginatedDataBranch,"Exportation bon de caisse","BonDeCaisse")
          // Appeler ici ta fonction d’export Excel
          break;
        case 'pdf':
          //console.log('Export PDF', data);
          // Appeler ici ta fonction d’export PDF
          GlobalExportToPDF(paginatedDataBranch,"Exportation bon de caisse ","BonDeCaisse")
          break;
           case 'word':
          //console.log('Export PDF', data);
          // Appeler ici ta fonction d’export PDF
          GlobalExportToWord(paginatedDataBranch,"Exportation bon de caisse ","TableauInteretsBDC")
          break;
        case 'csv':
         // console.log('Export CSV', data);
          // Appeler ici ta fonction d’export CSV
         GlobalExportToCSV(paginatedDataBranch,"Exportation bon de caisse ","BonDeCaisse") 
          break;
        case 'json':
         // console.log('Export JSON', data);
          // Appeler ici ta fonction d’export JSON
          GlobalExportToJSON(paginatedDataBranch,"Exportation bon de caisse ","BonDeCaisse") 
          break;
        default:
          break;
      }
    };

    const handleExportInt = (format: any) => {
      handleCloseExportInt();
      switch (format) {
        case 'excel':
         // console.log('Export Excel', data);
          GlobalExportToExcel(echeancier,"Exportation tableau imputaion interets "+selected?.NUMBDC+"-"+selected?.NOMCLI,"TableauInteretsBDC")
          // Appeler ici ta fonction d’export Excel
          break;
        case 'pdf':
          //console.log('Export PDF', data);
          // Appeler ici ta fonction d’export PDF
          GlobalExportToPDF(echeancier,"Exportation tableau imputaion interets "+selected?.NUMBDC+"-"+selected?.NOMCLI,"TableauInteretsBDC")
          break;
           case 'word':
          //console.log('Export PDF', data);
          // Appeler ici ta fonction d’export PDF
          GlobalExportToWord(echeancier,"Exportation tableau imputaion interets "+selected?.NUMBDC+"-"+selected?.NOMCLI,"TableauInteretsBDC")
          break;
        case 'csv':
         // console.log('Export CSV', data);
          // Appeler ici ta fonction d’export CSV
         GlobalExportToCSV(echeancier,"Exportation tableau imputaion interets "+selected?.NUMBDC+"-"+selected?.NOMCLI,"TableauInteretsBDC") 
          break;
        case 'json':
         // console.log('Export JSON', data);
          // Appeler ici ta fonction d’export JSON
          GlobalExportToJSON(echeancier,"Exportation tableau imputaion interets "+selected?.NUMBDC+"-"+selected?.NOMCLI,"TableauInteretsBDC") 
          break;
        default:
          break;
      }
    };
    // 🔹 Ferme le menu
  const handleCloseExport = () => {
    setAnchorEl(null);
  };
  

  const handleCloseExportInt = () => {
    setAnchorElInt(null);
  };
  
     function calculer(row: IBonDeCaisse) {
      setSelected(row);
      const prochaineDate = new Date(row.DATDEBUT  || Perss.datjour);
      
    
      const freq = (row.FREQPROV || "").toUpperCase();
      const montant = Number(row.MONTANT) || 0;
      const tauxInteret = Number(row.TXINT) || 0;
      const tauxTaxe = Number(row.TXTAXE) || 0;
      const duree = Number(row.DUREE) || 0; 
    
    
      // 🔹 2. Déterminer la durée en jours selon la fréquence
      let jours = 0;
      switch (freq) {
        case "A": jours = 360; break;   // Annuel
        case "S": jours = 180; break;   // Semestriel
        case "T": jours = 90; break;    // Trimestriel
        case "M": jours = 30; break;    // Mensuel
        case "B": jours = 15; break;    // Bimensuel
        case "F": jours = 60; break;    // Bimestriel
        case "H": jours = 7; break;     // Hebdomadaire
        case "J": jours = 1; break;     // Journalier
        default: jours = 30;            // Valeur par défaut
      }
    
      
        prochaineDate.setDate(prochaineDate.getDate() + jours * duree);
      
      
        //form.setFieldValue("DATFIN", prochaineDate.toISOString().split("T")[0]);
       // alert(form.getFieldValue("DATFIN"))
      // // 🔹 3. Calculs financiers
      // const montInt = (montant * tauxInteret * duree * jours) / 36000; // intérêt brut
      // const montTaxe = (montInt * tauxTaxe) / 100;                      // taxe totale
      // const montNet = montInt - montTaxe;                               // net à percevoir
      // const montTaxeFreq = montTaxe / duree;                            // taxe par période
      // const montProvFreq = montInt / duree;                             // provision par période
     
          // 1️⃣ Calcul brut de l'intérêt
let montIntBrut = (montant * tauxInteret * duree * jours) / 36000;

// 2️⃣ Calcul provisoire de l'intérêt par période (avant recalage)
let montProvFreq = Math.round(montIntBrut / duree);

// 3️⃣ Recalage de l'intérêt total
let montInt = montProvFreq * duree;

// 4️⃣ Calcul brut de la taxe (avant arrondis)
let montTaxeBrut = (montInt * tauxTaxe) / 100;

// 5️⃣ Calcul provisoire de la taxe périodique
let montTaxeFreq = Math.round(montTaxeBrut / duree);

// 6️⃣ Recalage de la taxe totale
let montTaxe = montTaxeFreq * duree;

// 7️⃣ Net perçu
let montNet = montInt - montTaxe;

      // 🔹 4. Calcul de la date de fin
      const dateFin = new Date(prochaineDate);
      dateFin.setDate(prochaineDate.getDate() + jours * duree);
    
      // 🔹 5. Génération du tableau d’échéances
      //const echeancier = [];
      //let dateEcheance = new Date(prochaineDate);
      let dateEcheance = new Date(row.DATDEBUT|| Perss.datjour);
     // const echeancier: any[] = []; // 🔥 reset obligatoire à chaque calcul
      const newEcheancier = [];
      for (let i = 1; i <= duree; i++) {
        const prochaine = new Date(dateEcheance);
        prochaine.setDate(prochaine.getDate() + jours);
    
        newEcheancier.push({
          periode: i,
          dateImput: dateEcheance.toLocaleDateString(),
          //dateFin: prochaine.toLocaleDateString(),
          interet: montProvFreq,
          taxe: montTaxeFreq,
          netAPayer: montProvFreq - montTaxeFreq,
        });
    
        dateEcheance = prochaine;
      }
     
      // // 🔹 6. (optionnel) Notification
      // Swal.fire({
      //   icon: "info",
      //   title: "Calcul terminé",
      //   html: `
      //     <p><b>Intérêt brut :</b> ${montInt.toFixed(2)}</p>
      //     <p><b>Taxe :</b> ${montTaxe.toFixed(2)}</p>
      //     <p><b>Net à percevoir :</b> ${montNet.toFixed(2)}</p>
      //   `,
      // });

  setResultat({
  montInt,
  montTaxe,
  montNet,
 // newEcheancier,
});
setEcheancier(newEcheancier);
setOpenDialog(true);
      // setCal(true)
    }
    
  
  // 📄 Filtrage des données en fonction du terme de recherche
    const filteredDataBranch = data.filter((item) =>
      Object.values(item).some(val =>
        String(val).toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
    // 📄 Pagination après filtrage
    const paginatedDataBranch = filteredDataBranch.slice(
      page * rowsPerPage,
      page * rowsPerPage + rowsPerPage
    );
  
    // 🔁 Gestion du changement de page
    const handleChangePage = (event: unknown, newPage: number) => {
      setPage(newPage);
    };
  
    // 🔁 Gestion du changement de nombre de lignes
    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0); // Revenir à la première page après changement
    };

 
 

//   const onSubmit = async (values: IBonDeCaisse) => {
//const onSubmit: SubmitHandler<IBonDeCaisse> = async (values) => {
const onSubmit = async (values: any) => {       
          try {       
      
                values.CODAGE=Perss.codage
                values.DATDEBUT=watch("DATDEBUT")
                values.DATEFIN=watch("DATFIN")
                values.CDETAT=cdetat
                 values.PENALITE=0;
                   values.INTACQUIS=0;
                    values.INTDUS=0;
        
                            let data = Crypter.encrypt(JSON.stringify(values));
                            let config = {
                                method: 'get',
                                maxBodyLength: Infinity,
                                url: Data.ApiUrl.ReadBonDeCaisseByAgence,
                                headers: {
                                    'CypherBonDeCaisse': data,
                                    'Authorization': authHeader(),
                                    'Content-Type': 'application/json'
                                },
                                data: data
                            };
        
                            axios.request(config)
                                .then((response) => {
                                   
                                    if (response.data) {
                                        const res = JSON.parse(Crypter.decrypt(response.data));
                                      
                                        if (res.StatutCode == 200) {
                                          const data: IBonDeCaisse[] =  res.Result?.Table || []
                                         // console.log(data)
                                           setData(data)
                                        }
                                       
                                    }
                                })
                               
           
   } catch (err) {
                console.error("Erreur de chargement:", err);
               // setError("Impossible de charger les données .");
               } finally {
                //setLoading2(false);
                return []
   }           
         
    
  };

 
  

  return (
   
 <Box mt={3} ml={2} mr={2}  fontStyle="inherit" className='border' width={"85%"} position={"absolute"}  sx={{p:1, height: 'auto',overflowY: 'visible'}}>
             <Box mb={2}>
                {/* <h3>Liste des simulations bon de caisse</h3> */}
                 <legend style={{ fontSize: '1.5rem' }} > Visualisation des bons de caisse</legend>
              </Box>

        <Tabs
            value={tab}
            onChange={(_, v) => setTab(v)}
            sx={{
              borderBottom: "1px solid black",
              mb: 2,
              "& .MuiTab-root": {
                border: "1px solid white",
                borderRadius: "5px 5px 0 0",
                marginRight: 1,
                backgroundColor: "transparent",
                color: "black", // <-- inactif = noir
                fontWeight: "bold",
                textTransform: "none",
                transition: "all 0.3s ease",
                minHeight: 35,
                "&:hover": {
                  color: "blue",
                  cursor: "pointer",
                },
                "&.Mui-selected": {
                  color: "white",     // <-- actif = blanc
                  backgroundColor: "#008040",
                },
              },
            }}
          >
      <Tab label="Liste des BDC" icon={<ListIcon />} iconPosition="start" />
      <Tab
        label={selected ? "Détail BDC" : "Détail BDC"}
        icon={<Filter />}
        iconPosition="start"
      />
        </Tabs>


      {tab === 0 && (
        <Box   sx={{ p:1,  borderRadius: 3, background:'white'}}
        component="form"
          onSubmit={handleSubmit(onSubmit)}
        >
            
             <Box  mb={3} sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            {/* Groupe de boutons à gauche */}
            <Box sx={{ display: "flex", gap: "10px" }}>
              {/* <Button
                variant="contained"
                color="primary"
                startIcon={<AddIcon />}
                onClick={handleNew}
                 sx={{ borderRadius: 2, fontWeight: 'bold' }}
              >
                Ajouter
              </Button> */}
             
              <Button
                variant="contained"
                color="primary"
                type="submit" 
                startIcon={<VisibilityIcon />}
                //onClick={() => fetchData("")}
                 sx={{ borderRadius: 2, fontWeight: 'bold' }}
              >
                Consulter
              </Button>

               {/* <Button
                variant="contained"
                color="primary"
                startIcon={<RefreshIcon />}
                onClick={() => fetchData("")}
                 sx={{  borderRadius: 2, fontWeight: 'bold' }}
              >
                Actualiser
              </Button> */}
            </Box>
          
            {/* Bouton Exporter à droite */}
            <Button
              variant="contained"
              color="success"
              startIcon={<GetAppIcon />}
              onClick={handleClickExport}
              
              sx={{ borderRadius: 2, fontWeight: 'bold' }}
            >
              Exporter
            </Button>
          
            {/* Menu pour les formats d'exportation */}
            <Menu
              anchorEl={anchorEl}
              // open={open1}
               open={Boolean(anchorEl)}    // ouvert si anchorEl != null
              onClose={handleCloseExport}
               anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'right',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                    }}
          
              PaperProps={{
                sx: {
                  borderRadius: 3,
                  mt: 1,
                  minWidth: 180,
                },
              }}
               
            >
              <MenuItem onClick={() => handleExport('excel')}>
                <ListItemIcon><TableChartIcon color="primary" /></ListItemIcon>
                <ListItemText>Excel (.xlsx)</ListItemText>
              </MenuItem>
              <MenuItem onClick={() => handleExport('pdf')}>
                <ListItemIcon><PictureAsPdfIcon color="error" /></ListItemIcon>
                <ListItemText>PDF (.pdf)</ListItemText>
              </MenuItem>
              <MenuItem onClick={() => handleExport('word')}>
               <DescriptionIcon sx={{ color: "#2B579A" }} /> {/* Bleu Word */}
                <ListItemText>Word (.docx)</ListItemText>
              </MenuItem>
              <MenuItem onClick={() => handleExport('csv')}>
                <ListItemIcon><ArticleIcon color="info" /></ListItemIcon>
                <ListItemText>CSV (.csv)</ListItemText>
              </MenuItem>
              <MenuItem onClick={() => handleExport('json')}>
                <ListItemIcon><DescriptionIcon color="secondary" /></ListItemIcon>
                <ListItemText>JSON (.json)</ListItemText>
              </MenuItem>
            </Menu>
          </Box>
              
              <Grid container spacing={2} mb={2}>
                <Grid item xs={12}>
                     <FormControl>
                        <FormLabel>Choisissez une option</FormLabel>
                        <RadioGroup row
                            value={cdetat}
                            onChange={(e) => {
                                setCdetat(e.target.value);
                                setData([])
                            }}
                        >
                            
                            <FormControlLabel value="01" control={<Radio />} label="Encours de validation" />
                            <FormControlLabel value="02" control={<Radio />} label="Validés" />
                            <FormControlLabel value="03" control={<Radio />} label="Rejetés" />
                            <FormControlLabel value="04" control={<Radio />} label="Echus" />
                        </RadioGroup>
                    </FormControl>
                </Grid>
              
              </Grid>
             
               <Grid container spacing={2} mb={2}>
                     <Grid item xs={1.5}>
                            <TextField label="Date debut" size="small" type="date" 
                            // disabled={true}
                            fullWidth {...register("DATDEBUT")}  
                            //InputLabelProps={{ shrink: true }}
                              sx={{
                                borderRadius: 10,
                                "& .MuiInputLabel-root": {
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                },
                                "& .MuiOutlinedInput-root legend": {
                                  maxWidth: 0,
                                }
                              }}
                                InputLabelProps={{ shrink: watch("DATDEBUT") ? true : false }}
                            />
                      </Grid>
                      <Grid item xs={1.5}>
                            <TextField label="Date fin" size="small" type="date" 
                            // disabled={true}
                            fullWidth {...register("DATFIN")}  
                            // InputLabelProps={{ shrink: true }}
                            sx={{
                                borderRadius: 10,
                                "& .MuiInputLabel-root": {
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                },
                                "& .MuiOutlinedInput-root legend": {
                                  maxWidth: 0,
                                }
                              }}
                              InputLabelProps={{ shrink: watch("DATFIN") ? true : false }}
                            />
                      </Grid>
                    
                </Grid>
             
           
            {/* Zone de recherche */}
                                                       
               <Box sx={{ mb: 2 }}>
                <TextField
                  label="Recherche"
                  variant="outlined"
                  fullWidth
                  size="small"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  InputLabelProps={{
                    sx: {
                      fontWeight: 'bold',
                    },
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        {/* Icône cliquable */}
                        <IconButton  edge="end">
                          <SearchIcon color="primary" />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>
          {/* <Button
            variant="contained"
            color="primary"
            onClick={handleNew}
            sx={{ mb: 2 }}
          >
            Nouveau BDC
          </Button> */}
          <TableContainer component={Paper}
          elevation={3} sx={{
                        // --- Styles pour les ascenseurs ---
                        maxHeight: 'auto', // Hauteur maximale pour l'ascenseur vertical (ajustez selon besoin)
                        overflowY: 'auto', // Active l'ascenseur vertical si le contenu dépasse
                        overflowX: 'auto', // Active l'ascenseur horizontal si le contenu dépasse
                        width: '100%', // S'assure que le conteneur prend toute la largeur disponible
                        minWidth: '900', // Optionnel: Si vous voulez une largeur minimale pour le conteneur
                      }}>
            <Table>
              <TableHead>
                <TableRow sx={{  height: 32, minHeight: 32, size:"small",  }}>
                <TableCell sx={{ color: '#fff', py: 1,backgroundColor: "#107C41", fontWeight:"bold"}}>Code </TableCell>
                <TableCell sx={{ color: '#fff', py: 1,backgroundColor:" #107C41", fontWeight:"bold"}}>Indice client</TableCell>
                <TableCell sx={{ color: '#fff', py: 1,backgroundColor:" #107C41", fontWeight:"bold"}}>Nom client</TableCell>
                <TableCell sx={{ color: '#fff', py: 1,backgroundColor:" #107C41", fontWeight:"bold"}}>Type BDC</TableCell>
                <TableCell sx={{ color: '#fff', py: 1,backgroundColor: " #107C41", fontWeight:"bold"}}>Fréquence</TableCell>
                <TableCell sx={{ color: '#fff', py: 1,backgroundColor: " #107C41", fontWeight:"bold"}}>Durée</TableCell>
                <TableCell sx={{ color: '#fff', py: 1,backgroundColor: " #107C41", fontWeight:"bold"}}>Montant</TableCell>
                <TableCell sx={{ color: '#fff', py: 1,backgroundColor: " #107C41", fontWeight:"bold"}}>Taux interêt</TableCell>
                <TableCell sx={{ color: '#fff', py: 1,backgroundColor: " #107C41", fontWeight:"bold"}}>Montant interet</TableCell>
                <TableCell sx={{ color: '#fff', py: 1,backgroundColor: " #107C41", fontWeight:"bold"}}>Taux taxe</TableCell>
                <TableCell sx={{ color: '#fff', py: 1,backgroundColor: " #107C41", fontWeight:"bold"}}>Monatnt taxe</TableCell>
                {/* <TableCell sx={{ color: '#fff', py: 1,backgroundColor: " #107C41", fontWeight:"bold"}}>Date début</TableCell>
                <TableCell sx={{ color: '#fff', py: 1,backgroundColor: " #107C41", fontWeight:"bold"}}>Date fin</TableCell> */}
                <TableCell sx={{ color: '#fff', py: 1,backgroundColor: " #107C41", fontWeight:"bold"}}>Crée le</TableCell>
                  <TableCell sx={{ color: '#fff', py: 1,backgroundColor: " #107C41", fontWeight:"bold"}}>Crée par</TableCell>
                  {/* <TableCell sx={{ color: '#fff', py: 1,backgroundColor: " #107C41", fontWeight:"bold"}}>Status</TableCell> */}
                <TableCell sx={{ color: '#fff', py: 1,backgroundColor: " #107C41", fontWeight:"bold"}}>Actions</TableCell>
              </TableRow>
              </TableHead>
              <TableBody>
                   {paginatedDataBranch.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={10} align="center">Aucune entrée de code trouvée.</TableCell>
                      </TableRow>
                    ) : (
                      paginatedDataBranch.map((item,index) => (
                        <TableRow   key={`${item.IDBDC}-${item.NUMCLI}-${item.CODAGE}`}  sx={{
                          cursor: 'pointer',
                          backgroundColor: index % 2 === 0 ? '#f5f5f5' : '#ffffff',
                          '&:hover': {
                          // backgroundColor: '#e0f7fa', // Couleur au survol
                          // background: `linear-gradient(90deg, #1c3adc 0%, #365eff 100%)`,
                          //color: '#fff', // Texte blanc sur fond sombre
                          background: 'linear-gradient(90deg, #eaf3ff 0%, #dceeff 100%)',
                            },
                                  }} > 
                          {/* Clé unique pour React */}
                          <TableCell sx={{ py: 0 }}>{item.NUMBDC}</TableCell>
                          <TableCell sx={{ py: 0 }}>{item.NUMCLI}</TableCell>
                          <TableCell sx={{ py: 0 }}>{item.NOMCLI}</TableCell>
                          <TableCell sx={{ py: 0 }}>{item.TYPBDC}</TableCell>
                          <TableCell sx={{ py: 0 }}>{item.FREQPROV}</TableCell>
                          <TableCell sx={{ py: 0,textAlign: 'right' }}>{(item.DUREE)}</TableCell>
                          <TableCell sx={{ py: 0,textAlign: 'right' }}>{formatNumber(Number(item.MONTANT))}</TableCell>
                          <TableCell sx={{ py: 0 ,textAlign: 'right'}}>{ (item.TXINT)}</TableCell>
                          <TableCell sx={{ py: 0,textAlign: 'right' }}>{formatNumber(Number(item.MTNINT))}</TableCell>
                          <TableCell sx={{ py: 0,textAlign: 'right' }}>{(item.TXTAXE)}</TableCell>
                          <TableCell sx={{ py: 0,textAlign: 'right' }}>{formatNumber(Number(item.MTNTAXE))}</TableCell>
                          {/* <TableCell sx={{ py: 0 }}> {item.DATDEBUT ? new Date(item.DATDEBUT).toLocaleDateString() : 'N/A'}</TableCell>
                          <TableCell sx={{ py: 0 }}> {item.DATFIN ? new Date(item.DATFIN).toLocaleDateString() : 'N/A'}</TableCell> */}
                          <TableCell sx={{ py: 0 }}> {item.DATCRE ? new Date(item.DATCRE).toLocaleDateString() : 'N/A'}</TableCell>
                          <TableCell sx={{ py: 0 }}>{item.UTISAI ?? 'N/A'}</TableCell>
                          {/* <TableCell sx={{ py: 0 }}>{item.CDETAT ?? 'N/A'}</TableCell> */}
                          
                          <TableCell sx={{ py: 0 }}>
                           
                            <IconButton color="success" onClick={() =>calculer(item)}>
                              <ListIcon />
                            </IconButton>
                             
                          </TableCell>
                        </TableRow>
                      ))
                    )}
               
              </TableBody>
            </Table>

          </TableContainer>

          {/* Pagination */}
          <TablePagination
                component="div"
                count={filteredDataBranch.length}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                rowsPerPageOptions={[5, 10, 25, 50]}
                labelRowsPerPage="Lignes par page"
            />
        </Box>
      )}

   

      <Dialog
  open={openDialog}
  onClose={() => setOpenDialog(false)}
  maxWidth="lg"
  fullWidth
>
  <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" ,backgroundColor: "#107C41",
    color: "white", }}
  >Tableau imputation des interets {selected?.NUMBDC+"-"+selected?.NOMCLI}
   <IconButton onClick={() => setOpenDialog(false)} size="small">
    <CloseIcon />
  </IconButton>
  </DialogTitle>

  <DialogContent sx={{ minHeight: 300 }}>

    {/* Résumé */}
    {echeancier && (
      <Box
  sx={{
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    mt: 2,
    mb: 2,
    px: 1,
  }}
>
  {/* 🔹 Infos sur une ligne */}
  <Box sx={{ display: "flex", gap: 3 }}>
    <p>
      <b>Intérêt brut :</b>{" "}
      {Intl.NumberFormat("fr-FR", { minimumFractionDigits: 2 }).format(resultat.montInt)}
    </p>

    <p>
      <b>Taxe :</b>{" "}
      {Intl.NumberFormat("fr-FR", { minimumFractionDigits: 2 }).format(resultat.montTaxe)}
    </p>

    <p>
      <b>Net à percevoir :</b>{" "}
      {Intl.NumberFormat("fr-FR", { minimumFractionDigits: 2 }).format(resultat.montNet)}
    </p>
  </Box>

  {/* 🔹 Bouton exportation */}
  <Button
    variant="contained"
    color="success"
    startIcon={<GetAppIcon />}
    onClick={handleClickExportInt}
    sx={{ borderRadius: 2, fontWeight: "bold" }}
  >
    Exporter
  </Button>
   {/* Menu pour les formats d'exportation */}
            <Menu
              anchorEl={anchorElInt}
              // open={open1}
               open={Boolean(anchorElInt)}    // ouvert si anchorEl != null
              onClose={handleCloseExportInt}
               anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'right',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                    }}
          
              PaperProps={{
                sx: {
                  borderRadius: 3,
                  mt: 1,
                  minWidth: 180,
                },
              }}
               
            >
              <MenuItem onClick={() => handleExportInt('excel')}>
                <ListItemIcon><TableChartIcon color="primary" /></ListItemIcon>
                <ListItemText>Excel (.xlsx)</ListItemText>
              </MenuItem>
              <MenuItem onClick={() => handleExportInt('pdf')}>
                <ListItemIcon><PictureAsPdfIcon color="error" /></ListItemIcon>
                <ListItemText>PDF (.pdf)</ListItemText>
              </MenuItem>
              <MenuItem onClick={() => handleExportInt('word')}>
               <DescriptionIcon sx={{ color: "#2B579A" }} /> {/* Bleu Word */}
                <ListItemText>Word (.docx)</ListItemText>
              </MenuItem>
              <MenuItem onClick={() => handleExportInt('csv')}>
                <ListItemIcon><ArticleIcon color="info" /></ListItemIcon>
                <ListItemText>CSV (.csv)</ListItemText>
              </MenuItem>
              <MenuItem onClick={() => handleExportInt('json')}>
                <ListItemIcon><DescriptionIcon color="secondary" /></ListItemIcon>
                <ListItemText>JSON (.json)</ListItemText>
              </MenuItem>
            </Menu>
   </Box>

   
    )}

    {/* Tableau des échéances */}
    {echeancier && (
   
      <Box mb={1} fontStyle="inherit" className='border' sx={{p:1}}>
        <Grid item xs={12}>
        <TableContainer component={Paper} sx={{ mt: 2 }}>
          <Table size="small">
          <TableHead>
            <TableRow sx={{  height: 32, minHeight: 32, size:"small",  }}>
              <TableCell sx={{ color: '#fff', py: 1,backgroundColor: "#107C41", fontWeight:"bold"}}>Période</TableCell>
              <TableCell sx={{ color: '#fff', py: 1,backgroundColor: "#107C41", fontWeight:"bold"}}>Date imputation</TableCell>
           
              <TableCell sx={{ color: '#fff', py: 1,backgroundColor: "#107C41", fontWeight:"bold"}} align="right">Intérêt</TableCell>
              <TableCell sx={{ color: '#fff', py: 1,backgroundColor: "#107C41", fontWeight:"bold"}} align="right">Taxe</TableCell>
              <TableCell sx={{ color: '#fff', py: 1,backgroundColor: "#107C41", fontWeight:"bold"}} align="right">Net à payer</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {echeancier.map((row:any,index:number) => (
              <TableRow key={row.periode} sx={{
                                            cursor: 'pointer',
                                            backgroundColor: index % 2 === 0 ? '#f5f5f5' : '#ffffff',
                                             '&:hover': {
                                             // backgroundColor: '#e0f7fa', // Couleur au survol
                                             // background: `linear-gradient(90deg, #1c3adc 0%, #365eff 100%)`,
                                             //color: '#fff', // Texte blanc sur fond sombre
                                             background: 'linear-gradient(90deg, #eaf3ff 0%, #dceeff 100%)',
                                                 },
                                             }}>
                <TableCell>{row.periode}</TableCell>
                <TableCell>{row.dateImput}</TableCell>
                
                <TableCell align="right">{row.interet.toFixed(2)}</TableCell>
                <TableCell align="right">{row.taxe.toFixed(2)}</TableCell>
                <TableCell align="right">{row.netAPayer.toFixed(2)}</TableCell>
              </TableRow>
            ))}
          </TableBody>

          {/* Table Footer pour les totaux */}
    <TableFooter>
      <TableRow sx={{ backgroundColor: "#107C41", color: "#fff", fontWeight: "bold" }}>
        <TableCell colSpan={2} sx={{ color: '#fff', fontWeight: "bold" }}>Total</TableCell>
        <TableCell align="right" sx={{ color: '#fff', fontWeight: "bold" }}>{totalInteret.toFixed(2)}</TableCell>
        <TableCell align="right" sx={{ color: '#fff', fontWeight: "bold" }}>{totalTaxe.toFixed(2)}</TableCell>
        <TableCell align="right" sx={{ color: '#fff', fontWeight: "bold" }}>{totalNet.toFixed(2)}</TableCell>
      </TableRow>
    </TableFooter>
          </Table>
          </TableContainer>
        </Grid>     
      </Box>
    )}

  </DialogContent>
     </Dialog>

  </Box>
   
   
  );
}
